import * as _ from "lodash";

import { Input, Select } from "@/components";
import { Map } from "@/utils";

import SettingsTab from "../Tab";

const renderContent = ({ model, changeFormState, FormControl }) => {
    const positioningTypeOptions = _.map(
        Map.Collections.positioningTypes,
        (positionType) => ({
            value: positionType,
            label: positionType,
        }),
    );

    return (
        <div>
            <div className="row">
                <FormControl
                    className="col-sm-5"
                    name="positioningType"
                    required
                >
                    <label className="selectLabel">
                        Positioning Type<span className="asterisk">*</span>
                    </label>
                    <Select
                        required
                        value={model.positioningType}
                        onChange={({ value }) =>
                            changeFormState({
                                positioningType: value,
                            })
                        }
                        options={positioningTypeOptions}
                    />
                </FormControl>
            </div>
            <div className="row">
                <FormControl className="col-sm-4" name="operationPoint">
                    <Input
                        value={model.operatingPoint}
                        label="Operating Point"
                        onChange={(value) =>
                            changeFormState({
                                operatingPoint: value,
                            })
                        }
                        type="number"
                    />
                </FormControl>
                <FormControl
                    className="col-sm-5 max-mounting-height"
                    name="maxMountingHeight"
                    required
                >
                    <Input
                        value={model.maxMountingHeight}
                        label="Max Mounting Height (feet)"
                        onChange={(value) =>
                            changeFormState({
                                maxMountingHeight: value === "0" ? "" : value,
                            })
                        }
                        type="number"
                        required
                        decimalDigits={2}
                    />
                </FormControl>
            </div>
            <div className="row">
                <FormControl className="col" name="fixturesTypes">
                    <label className="required">Fixture Types</label>
                    <Select
                        multi
                        placeholder="Filter and select one or more fixture types…"
                        value={model.types}
                        options={Map.Collections.fixtureTypes}
                        onChange={(selectedOptions) =>
                            changeFormState({
                                types: selectedOptions,
                            })
                        }
                    />
                </FormControl>
            </div>
        </div>
    );
};

/**
 * Settings tab for configuring fixture positioning type and properties.
 *
 * @param props - The settings tab props including model and form state.
 * @returns The rendered fixture settings tab.
 */
const FixtureTab = (props) => (
    <SettingsTab {...props} renderContent={renderContent} />
);

export default FixtureTab;
